/* eslint-disable react/destructuring-assignment */
/* eslint-disable radix */
/* eslint-disable no-param-reassign */
/* eslint-disable compat/compat */
// import image from '../../../img/promo-carousel-bg.jpg';

export default (function () {
  return {
    init() {
      const promoCarousel = document.querySelectorAll('.promotional-carousel');
      this.getPreviousSection(promoCarousel);
    },

    getPreviousSection(section) {
      section.forEach((item) => {
        if (item.nextElementSibling !== null) {
          item.nextElementSibling.classList.add('negative');
        } else {
          item.closest('.main').nextElementSibling.classList.add('negative');
        }
      });
    },
  };
})();
